import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'location-sitemap',
		path: '/local',
		component: loadable(async () => import(/* webpackChunkName: "pages/local-sitemap" */ './index'), {
			exportName: 'LocationSitemap',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
